export default __webpack_public_path__ + "assets/images/863f8d13167307e0b28835bc25cf5f86.png";